import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Checkout from "./views/Checkout.vue";
import Cart from "./views/Cart.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/cart",
    },
    {
      path: "/cart",
      name: "cart",
      component: Cart,
    },
    {
      path: "/checkout",
      name: "checkout",
      component: Checkout,
      alias: "/info", // v3 compat
    },
    {
      path: "/home",
      name: "home",
      component: Home,
    },
    {
      path: "/*",
      name: "default",
      redirect: "/cart",
    },
  ],
});
